import { create } from 'zustand';
import MuvikaService from '../services/muvika';
import messageStore from './message';
import { subscribeWithSelector } from 'zustand/middleware';

const initialState = {
  isSet: false,
  totalCount: 0,
  isWaiting: false,
  isFinished: false,
  currentPage: 1,
  tracks: null,
  newTracksTitle: null,
  newTracksIndex: 0,
};

const newTracksStore = create(subscribeWithSelector((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  rollNewTracks: () => {
    let index = get().newTracksIndex;
    index += 5;
    if (index == 10) {
      index = 0;
    }
    set({ newTracksIndex: index });
  },
  setNewTracksTitle: (title) => {
    set({ newTracksTitle: title });
  },
  resetLatest: () => {
    set({ isSet: false, tracks: null, totalCount: 0, isWaiting: true });
  },
  getLatest: (sessionToken, pageSize) => {
    set({ currentPage: 1, isWaiting: true, isFinished: false });
    MuvikaService.getLatest(sessionToken, pageSize, 1)
      .then(function (res) {
        if (res.data.error) {
          set({ isSet: false, totalCount: 0, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ isSet: true, tracks: res.data.data.items, totalCount: res.data.data.items_total, isWaiting: false });
        }
      })
      .catch(function () { });
  },
  getLatestMore: (sessionToken, pageSize) => {
    if (!get().isWaiting) {
      let page = get().currentPage + 1;
      set({ currentPage: page, isWaiting: true });
      MuvikaService.getLatest(sessionToken, pageSize, page)
        .then(function (res) {
          if (res.data.error) {
            set({ isSet: false, isWaiting: false });
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            let tracks = get().tracks;
            let tracksMore = res.data.data.items;
            if (tracksMore.length == 0) {
              set({ isFinished: true });
            }
            tracks = tracks.concat(tracksMore);
            set({ isSet: true, tracks: tracks, totalCount: res.data.data.items_total, isWaiting: false });
          }
        })
        .catch(function () { });
    }
  }
})));

export default newTracksStore;